import { atom, useAtom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

export const INITIAL_QUICK_BUY_AMOUNT = 1000000
export const MAXIMUM_QUICK_BUY_AMOUNT = 1000000000
const userQuickBuyAmountAtom = atomWithStorage('pcs:quickbuyamount', INITIAL_QUICK_BUY_AMOUNT)

const userQuickBuyAmountAtomWithLocalStorage = atom(
  (get) => get(userQuickBuyAmountAtom),
  (_get, set, quickBuyAmount: number) => {
    if (typeof quickBuyAmount === 'number') {
      set(userQuickBuyAmountAtom, quickBuyAmount)
    }
  },
)

export const useUserQuickBuyAmount = () => {
  return useAtom(userQuickBuyAmountAtomWithLocalStorage)
}